// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2edbt","requiredAsterisk":"Info_requiredAsterisk__3x7yX"};